import { render } from "./CollectionCardCreatorOwnerImage.vue?vue&type=template&id=750a53d6&scoped=true"
import script from "./CollectionCardCreatorOwnerImage.vue?vue&type=script&lang=js"
export * from "./CollectionCardCreatorOwnerImage.vue?vue&type=script&lang=js"

import "@/Common/Styles/nftCard.scss?vue&type=style&index=0&id=750a53d6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-750a53d6"]])

export default __exports__